import { create } from "zustand";
import { persist } from "zustand/middleware";
import { savedQuote } from "../util/quoteCartStorage";
import resetModalTextHandler from "../util/resetModalTextHandler";
import { UnitObj } from "../util/quoteCartStorage";

export type ErrorType = {
  widthErr?: string;
  widthErrCornerRight?: string;
  heightErr?: string;
  configErr?: string;
  swingWidthErr?: string;
  sideliteWidthErr?: string;
  primaryDoorErr?: string;
  pivotPointErr?: string;
  jambErr?: string;
  withExtSboltErr?: string;
  widthErrComboWindow?: string;
  heightErrComboWindow?: string;
};

interface CreateStore {
  quote: UnitObj;
  errors: ErrorType;
  resetModalText: string[];
  isEdit: boolean;
  getStore: () => UnitObj;
  handleError: (errKey: string, msg: string) => void;
  addToQuote: (updateObj: Partial<UnitObj>, ignoreKey?: string) => void;
  clearModalText: () => void;
  resetQuote: () => void;
  setStoreFromEdit: (unitInfo: UnitObj) => void;
  checkForEmptyVals: () => boolean;
}

export const useStore = create<CreateStore>()(
  persist(
    (set, get) => ({
      quote: { ...savedQuote },
      resetModalText: [],
      isEdit: false,
      getStore: () => {
        const storeQuote = get().quote;
        return storeQuote;
      },
      errors: {},
      handleError: (errKey: string, msg: string) =>
        set((state: CreateStore) => ({
          ...state,
          errors: {
            ...state.errors,
            [errKey]: msg,
          },
        })),
      addToQuote: (updateObj: Partial<UnitObj>, ignoreKey?: string) => {
        const prevQuote = get().quote;

        const newQuote = { ...prevQuote, ...updateObj };

        const modalText: string[] = resetModalTextHandler(
          prevQuote,
          newQuote,
          ignoreKey || ""
        );

        set((state: CreateStore) => ({
          ...state,
          resetModalText: modalText,
          quote: newQuote,
        }));
      },
      clearModalText: () =>
        set((state: CreateStore) => ({
          ...state,
          resetModalText: [],
        })),
      resetQuote: () =>
        set((state: CreateStore) => ({
          ...state,
          isEdit: false,
          quote: { ...savedQuote },
          errors: {},
          resetModalText: [],
        })),
      setStoreFromEdit: (unitInfo: UnitObj) =>
        set((state: CreateStore) => ({
          ...state,
          isEdit: true,
          resetModalText: ["None"],
          quote: unitInfo,
        })),
      checkForEmptyVals: () => {
        const storeReset = get().quote;

        var hasVals = false;

        for (const key in storeReset) {
          if (
            !hasVals &&
            key !== "doorType" &&
            key !== "quantity" &&
            key !== "glassType" &&
            key !== "breatherTubes" &&
            key !== "title24Comp" &&
            key !== "sideLite" &&
            key !== "sillStyle" &&
            key !== "addToQuote" &&
            key !== "resetQuote" &&
            key !== "checkForEmptyVals" &&
            key !== "material"
          ) {
            if (key in storeReset && storeReset[key]) {
              hasVals = true;
              break;
            }
          }
        }

        return hasVals;
      },
    }),
    {
      name: "store",
      partialize: (state: CreateStore) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) =>
              ![
                "checkForEmptyVals",
                "setStoreFromEdit",
                "addToQuote",
                "resetQuote",
                "clearModalText",
                "handleError",
                "getStore",
              ].includes(key)
          )
        ),
    }
  )
);
